import { DEVICES as devices } from './devices';
import { VIEW_USER as viewUser } from './viewUser';

export const MANAGE = {
  viewUser,
  devices
};
